import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import ReactHtmlParser from 'react-html-parser';

class SelectAndCustomizeButton extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.choseNewTheme) {
      return false;
    }
    return true;
  }

  handleClick(e) {
    e.preventDefault();
    const { clickHandler, weddingTheme, currentTheme, onboard } = this.props;

    if (weddingTheme.id === currentTheme.id) {
      browserHistory.push('/wedding/manage/website/pages/home');
    } else {
      clickHandler(currentTheme.id, onboard);
    }
  }

  render() {
    const { weddingTheme, currentTheme } = this.props;
    const text = (weddingTheme.id === currentTheme.id) ? 'Customize' : 'Select &amp; Customize';

    return (
      <button className="btn btn-primary theme-action" onClick={e => this.handleClick(e)}>
        { ReactHtmlParser(text) }
      </button>
    );
  }
}

SelectAndCustomizeButton.propTypes = {
  currentTheme: PropTypes.shape({}),
  weddingTheme: PropTypes.shape({}),
  clickHandler: PropTypes.func.isRequired,
  onboard: PropTypes.bool,
  choseNewTheme: PropTypes.bool,
};

export default SelectAndCustomizeButton;



// WEBPACK FOOTER //
// ./src/components/manage/common/SelectAndCustomizeButton.jsx